import { render, staticRenderFns } from "./DeviceAccessoryContextMenu.vue?vue&type=template&id=06e8f0e2&scoped=true&"
import script from "./DeviceAccessoryContextMenu.vue?vue&type=script&lang=js&"
export * from "./DeviceAccessoryContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAccessoryContextMenu.vue?vue&type=style&index=0&id=06e8f0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8f0e2",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DeviceTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Fdevice%2FDeviceAccessoryContextMenu.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports